<template>
  <v-row class="user-bio-panel">
    <v-col cols="12">
      <v-card class="">
        <v-card-title class="justify-center flex-column">
          <v-avatar
            :color="'primary'"
            :class="'v-avatar-light-bg primary--text'"
            size="120"
            rounded
            class="mb-4"
          >
            <v-img
              :src="eventData.firstImage || TSS_IMAGE_PLACEHOLDER"
              @error="eventData.firstImage = TSS_IMAGE_PLACEHOLDER"
            ></v-img>
          </v-avatar>

          <span class="mb-2">{{ getEventData.name }}</span>

          <v-chip
            label
            small
          >
            {{ getEventData.establishment.name }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <h2 class="text-xl font-weight-semibold mb-2">
            {{ $t('eventPage.details') }}
          </h2>

          <v-divider></v-divider>

          <v-list>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium me-2">{{ $t('eventPage.startAt') }}:</span>
              <span class="text--secondary">{{ getEventData.computed.dates.start().human().dateShortWithTime }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium me-2">{{ $t('eventPage.endAt') }}:</span>
              <span class="text--secondary">{{ getEventData.computed.dates.end().human().dateShortWithTime }}</span>
            </v-list-item>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium me-2">Total guests:</span>
              <span class="text--secondary">
                {{ getEventData.seats.totalTaken }}/{{ getEventData.seats.totalAccepted }}
                <v-chip
                  label
                  small
                >
                  {{ getEventData.seats.isFull ? $t('eventPage.full') : $t('eventPage.notFull') }}
                </v-chip>
              </span>
            </v-list-item>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium me-2">Female(s):</span>
              <span class="text--secondary text-capitalize">{{ getEventData.female_total_seats_taken }}/{{ getEventData.max_female_guest }}</span>
            </v-list-item>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium me-2">Male(s):</span>
              <span class="text--secondary">{{ getEventData.male_total_seats_taken }}/{{ getEventData.max_male_guest }}</span>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from '@vue/composition-api';
import { TSS_IMAGE_PLACEHOLDER } from '@/constants/global.constants';

export default {
  name: 'EventBio',
  props: {
    eventData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // Computed

    const getEventData = computed(() => ({
      ...props.eventData,
      seats: {
        totalAccepted: props.eventData.total_max_accepted,
        totalTaken: props.eventData.total_seats_taken,
        isFull: props.eventData.total_seats_taken === props.eventData.total_max_accepted,
      },
    }));

    // Return

    return {
      getEventData,
      TSS_IMAGE_PLACEHOLDER,
    };
  },
};
</script>
